<template>
  <div class="view-container">
    <!-- Show spash screen -->
    <div v-if="showLoader">
      <app-loader :fadeoutLoader="fadeoutLoader"></app-loader>
    </div>
    <div v-if="fadeoutLoader"></div>
    <div class="app-container text-center">
      <h3>Select a Franchise</h3>
      <v-select
        placeholder="Choose a franchise"
        :options="options"
        label="name"
        v-model="selectedFranchise"
      ></v-select>
      <br />
      <button class="btn update-franchise">Select</button>
    </div>
  </div>
</template>
<!-- Scripts -->
<script>
import loaderPartial from "@/components/LoaderPartial.vue";
import { splashScreen } from "@/mixins/splashScreen";
import { view } from "./Franchise.vue.js";

export default {
  name: "Franchise",
  components: {
    "app-loader": loaderPartial,
  },
  mixins: [splashScreen, view],
  data() {
    return {
      selectedFranchise: null,
      options: [],
    };
  },
  created() {
    var _self = this;

    if(!_self.$frachiseID)
      _self.showSplashScreen();

    this.$ooApi.orders.franchises.v1()
      .then(function (result) {
        _self.$franchiseLogoUrl = result.data.platinumLogoPath;
        _self.$franchiseBannerUrl = result.data.platinumOnlineBannerPath;
        _self.$franchiseAccentColor = result.data.platinumAccentColor;
        _self.options = result.data.franchises;
        _self.hideSplashScreen();
      });
  },
  mounted() {
    document
      .querySelector("button.update-franchise")
      .addEventListener("click", this.selectFranchise);
  },
};
</script>
<style>
@import "./Franchise.vue.css";
</style>
